import React from "react";
import { observer } from "mobx-react";
import { useEffect } from "react";
import PlusIcon from "../../../../../images/membership/plus-white.svg";
import styled from "styled-components";
import { MediaTypes } from "../enums";
import { MediaGridResponseModel, MediaModel } from "../models";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  IOption,
  ModalComponent,
  PaginationModel,
  SingleSelect,
  TablePagination,
} from "@mindmemobile/mm-shared-global";
import {  MediaService } from "../services";
import { ItemImage } from "../styles";
import { MediaStore } from "../store";
import SharedLibrary from "./SharedLibrary";
import { MediaItem, MediaType } from "@mindmemobile/mm-shared-library";
import { LibraryMediaWrapper } from "./MediaBoxes";

type IProps = {
  allowedMediaTypes?: (keyof typeof MediaType)[];
  mediaStore: MediaStore;
  onClose: () => void;
  onUpload: (media: MediaItem) => void;
  showUpload?: boolean;
};

const mediaOptions: IOption[] = [
  { value: "image", label: MediaTypes.Image },
  { value: "video", label: MediaTypes.Video },
];
const MediaLibraryPopUp: React.FC<IProps> = ({
  allowedMediaTypes,
  mediaStore,
  onClose,
  onUpload,
  showUpload,
}) => {
  useEffect(() => {
    // loadLibraryData(
    //   mediaStore.pagination.pageNumber,
    //   mediaStore.pagination.pageSize,
    //   "",
    //   mediaStore.mediaOption
    // );
  }, []);

  const loadLibraryData = async (
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filter: string
  ) => {
    const response = await MediaService.getMedias(
      AuthService.authData.accountId,
      pageNumber,
      pageSize,
      filter,
      searchValue
    ).toPromise();

    if (response) {
      const medias =
        response.result?.map((m: any) =>
          MediaGridResponseModel.deserializeAPIModel(m)
        ) || [];
      mediaStore.updateMedias(medias || []);
      const pagination = PaginationModel.deserialize(response.meta);
      mediaStore.updatePagination(pagination);
    }
  };

  function onPaginationChange(pageNumber: number, pageSize: number) {
    loadLibraryData(pageNumber, pageSize, mediaStore.searchValue, "");
  }

  const renderMedia = (media: MediaGridResponseModel) => {
    switch (media.type) {
      case MediaTypes.Video:
        return (
          <video style={{ width: "100%" }} controls={true}>
            <source type="video/ogg" src={media.url} />
            <source type="video/m4v" src={media.url} />
            <source type="video/mp4" src={media.url} />
            <source type="video/youtube" src={media.url} />
          </video>
        );
      default:
        return <img src={media.url} className="product-image" />;
    }
  };

  const onClickMedia = (media: MediaItem) => {
    // const mediaModel = MediaModel.fromMediaGridResponseModel(media);
    // mediaStore.updateMediaOption(mediaOptions[0].value);
    onUpload(media);
  };

  const onSingleSelectChange = (value: string) => {
    mediaStore.updateMediaOption(value);
    loadLibraryData(
      mediaStore.pagination.pageNumber,
      mediaStore.pagination.pageSize,
      mediaStore.searchValue,
      value
    );
  };

  const onClosePopup = () => {
    mediaStore.updateMediaOption(mediaOptions[0].value);
    onClose();
  };

  // const renderModalBody = () => {
  //   const filterAllowedMediaTypes = allowedMediaTypes
  //     ? mediaOptions.filter((m) => allowedMediaTypes.some((t) => t == m.label))
  //     : mediaOptions;

  //   return (
  //     <div>
  //       <FlexContainer>
  //         <SingleSelect
  //           selectedKey={mediaStore.mediaOption}
  //           searchable={false}
  //           nameKeys={["label"]}
  //           valueKeys={["value"]}
  //           options={[filterAllowedMediaTypes || []]}
  //           onChange={(option: any) => onSingleSelectChange(option.value)}
  //           className="media-type-select"
  //         />
  //       </FlexContainer>
  //       <FlexContainer
  //         fxLayout="row"
  //         spacing={30}
  //         fxWrap="wrap"
  //         padding="30px 0px 0px"
  //       >
  //         {mediaStore.medias.map((m, idx) => {
  //           return (
  //             <div
  //               key={idx}
  //               onClick={() => onClickMedia(m)}
  //               className="media-blocks"
  //             >
  //               <ItemImage bgColor="#ebeaea82">
  //                 {m.url && renderMedia(m)}
  //                 <div className="overlay-product">
  //                   <img src={PlusIcon} className="plus-hovered" />
  //                 </div>
  //               </ItemImage>
  //               <CustomLabel
  //                 fontSize="12px"
  //                 fontWeight="600"
  //                 className="library-image-label"
  //               >
  //                 {m.name}
  //               </CustomLabel>
  //             </div>
  //           );
  //         })}
  //       </FlexContainer>
  //     </div>
  //   );
  // };

  const renderModalBody1 = () => {
    if (!AuthService.mindmeAccountDetails) return;
    const { subAccountId, parentAccountId, userId } =
      AuthService.mindmeAccountDetails;
    return (
      <LibraryMediaWrapper className="lib-overlay-payment pay-lib-popup">
        <SharedLibrary
          onMediaItemClick={(mediaItem) => onClickMedia(mediaItem)}
          subAccountId={subAccountId}
          parentAccountId={parentAccountId}
          userId={userId}
          bearerToken=""
          showUpload={showUpload}
          allowedMediaTypes={allowedMediaTypes}
          apiBaseURL={process.env.REACT_APP_MINDME_MAIN_API || ""} // Ensure this is set in your environment variables
        />
      </LibraryMediaWrapper>
    );
  };

  return (
    <ModalComponent
      title="Upload Media"
      titleFontSize="22px"
      showFooter={false}
      minHeight="440px"
      bodyBackgroundColor="#fefefe"
      footerBackground="#F4F7FB"
      footerHeight="auto"
      onClose={() => onClose()}
      footerContent={null}
      // wrapperWidth="calc(100% - 100px)" //unsplash and pixabay needs atleast this to get 5 in a row
      wrapperWidth="1150px"
      maxHeight="144px"
    >
      {renderModalBody1()}
    </ModalComponent>
  );
};

export default observer(MediaLibraryPopUp);
